import React from 'react';
import { Button } from '../../../../constants/Button';
import Container from '../../../../constants/Container';
import { Grid } from '@mui/material';
import InputTextBox from '../../../../constants/InputTextBox';
import { CiCalendarDate } from 'react-icons/ci';
import { handleChangeDate, handleSelectBox } from '../../../../helpers/handleChange';
import { useFormik } from 'formik';
import { EndBaseLine } from '../../../../constants/AppSpace';
import SecHeading from '../../../../constants/SecHeading';
import SelectInputBox from '../../../../constants/SelectInputBox';
import AppURL from '../../../../constants/AppURL';
import useFetchData from '../../../../helpers/useFetch';
import { ReaderOptions } from '../../../../constants/Options';
import { NepNowDateFormat } from '../../../../constants/DateFormat';
import { postMahasulDataOnServer } from '../../../../helpers/submitDataOnServer';
import { fetchDataFromApi } from '../../../../helpers/api';
import { MahasulListDetailsProps } from '../../../../helpers/models/Models';
interface PostToAccountFormViewProps {
    setOnMahasulList: React.Dispatch<React.SetStateAction<MahasulListDetailsProps[] | null>>;
}
const PostToAccountFormView: React.FC<PostToAccountFormViewProps> = ({ setOnMahasulList }) => {
    const { data, loading, error, refetch } = useFetchData(AppURL.AccountURL + 'account/reader/details/list/view/');
    const readerOptions = ReaderOptions(data?.data);
    const date_ne = NepNowDateFormat();
    const initialValues = {
        date_n: date_ne || "",
        member_sn: "",
        reader: "",
    };

    const { values, errors, touched, setFieldValue, isSubmitting, handleBlur, handleChange, handleSubmit } = useFormik({
        initialValues,
        enableReinitialize: true,
        onSubmit: async (values, action) => {
            const formData = new FormData();
            formData.append("date_n", values.date_n);
            formData.append("member_sn", values.member_sn);
            formData.append("mem_id", values.member_sn);
            formData.append("reader", values.reader);
            await fetchDataFromApi(AppURL.AccountURL + 'account/mahasul/details/list/view/?date_ne=' + values.date_n + "&reader=" + values.reader).then((res) => {
                setOnMahasulList(res.data || null); // Use null if no data
            });
        },

    });
    const mahasulDataPostOnServer = async () => {
        await postMahasulDataOnServer(values.date_n, parseInt(values.reader));
    }
    return (
        <Container padding>
            <SecHeading type='add' label='Post to Account' />
            <Grid container spacing={2}>
                <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                    <InputTextBox
                        type='text'
                        prefix={<CiCalendarDate />}
                        handleChange={(e) => handleChangeDate(e, { setFieldValue, name: 'date_n' })}
                        label='Date(B.S.)'
                        name='date_n'
                        handleBlur={handleBlur}
                        value={values.date_n}
                        error={typeof errors.date_n === 'string' ? errors.date_n : undefined}
                        touched={!!touched.date_n}
                        placeholder='XXXX/XX/XX'
                        required={false}
                    />
                </Grid>
                <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                    <SelectInputBox
                        label='Reader'
                        options={readerOptions}
                        name='reader'
                        required={true}
                        placeholder='Select Reader'
                        optionSelect={(name, selectedOption) => {
                            handleSelectBox({ setFieldValue, name, value: selectedOption })
                        }}
                        handleBlur={handleBlur}
                        value={values.reader}
                        touched={touched.reader}
                        errors={errors.reader}
                    />
                </Grid>

                <Grid item xl={12} lg={12} sm={12} md={12} xs={12}>
                    <EndBaseLine top={19}>
                        <Button btn_type='list' onClick={()=>handleSubmit()} type='button' el='button' />
                        <Button btn_type='post' onClick={mahasulDataPostOnServer} type='button' el='button' />
                    </EndBaseLine>
                </Grid>
            </Grid>
        </Container>
    )
}

export default PostToAccountFormView